module.exports = __webpack_public_path__ + "img/not-found.d3364351.png";